module.exports = __webpack_public_path__ + "img/account.7bfd50a9.svg";